var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbars',{attrs:{"objects":_vm.internal_value},on:{"update:objects":function($event){_vm.internal_value=$event}},scopedSlots:_vm._u([{key:"action",fn:function({ close }){return [_c('v-btn',{attrs:{"color":"transparent","depressed":"","fab":"","small":""},on:{"click":close}},[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }